(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fit-finder-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    /**
     * STEP 1: Opens the fit finder drawer
     * Called from: theme.liquid when user clicks "What's My Size" button
     * 
     * Flow:
     * 1. User clicks "What's My Size" → theme.liquid calls this function
     * 2. This function opens the drawer dialog
     * 3. When drawer opens → handleDrawerOpen() automatically fires (via event listener)
     * 4. handleDrawerOpen() checks localStorage and shows form or results
     */
    function openFitFinderDrawer() {
      let drawer = document.getElementById('fit-finder-drawer');
    
      if (!drawer) {
        return;
      }
      
      // Check if drawer is initialized (check both drawer property and global fallback)
      const handleDrawerOpenFn = drawer._handleDrawerOpen || (typeof window !== 'undefined' ? window._fitFinderHandleDrawerOpen : null);
      
      if (!handleDrawerOpenFn) {
        let retries = 0;
        const maxRetries = 10;
        const checkInit = () => {
          drawer = document.getElementById('fit-finder-drawer');
          const fn = drawer?._handleDrawerOpen || (typeof window !== 'undefined' ? window._fitFinderHandleDrawerOpen : null);
          if (fn && typeof fn === 'function') {
            openFitFinderDrawer();
          } else if (retries < maxRetries) {
            retries++;
            setTimeout(checkInit, 50);
          } 
        };
        setTimeout(checkInit, 50);
        return;
      }
      
      // Store the function reference for use later
      const handleDrawerOpen = handleDrawerOpenFn;
      
      // Move drawer to body if it's inside a modal (so it appears on top)
      const quickAddModal = drawer.closest('.quick-add-modal, #quick-add-dialog');
      if (quickAddModal) {
        document.body.appendChild(drawer);
        // Get fresh reference after move (just to be safe)
        drawer = document.getElementById('fit-finder-drawer');
        if (!drawer) {
          return;
        }
      }
      
      // Open the drawer dialog
      const dialogEl = drawer.querySelector('dialog');
      if (!dialogEl) {
        return;
      }
      
      // Try to open using dialog-component methods first
      const openDialog = () => {
        if (customElements.get('dialog-component')) {
        if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
          } else if (drawer.refs?.dialog) {
          drawer.refs.dialog.showModal();
        } else {
            dialogEl.showModal();
          }
        } else {
          dialogEl.showModal();
        }
        
        // Explicitly call handleDrawerOpen after opening (fallback if events don't fire)
        // This is especially important when drawer is moved from quick-add-modal
        setTimeout(() => {
          const fn = handleDrawerOpen || drawer._handleDrawerOpen || (typeof window !== 'undefined' ? window._fitFinderHandleDrawerOpen : null);
          
          if (fn && typeof fn === 'function') {
            fn();
          } 
        }, 100);
      };
      
      if (customElements.get('dialog-component')) {
        openDialog();
      } else {
        // Wait for component to load, then open
        customElements.whenDefined('dialog-component').then(() => {
          openDialog();
        }).catch(() => {
          // Fallback: open directly
          openDialog();
        });
      }
      
      // Note: handleDrawerOpen() will automatically fire when dialog opens
      // (it's listening to 'dialog:open' and 'show' events)
      // We also call it explicitly as a fallback after 50ms
    }
    
    // Expose function globally so theme.liquid can call it
    if (typeof window !== 'undefined') {
      window.openFitFinderDrawer = openFitFinderDrawer;
    }
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      const drawer = document.getElementById('fit-finder-drawer');
      if (!drawer) return;

      const dialog = drawer.querySelector('dialog');
      const input = drawer.querySelector('#foot-length-input');
      const unitButtons = drawer.querySelectorAll('.fit-finder-drawer__unit-button');
      const getSizeButton = drawer.querySelector('.fit-finder-drawer__cta-button--get-size');
      const addCartButton = drawer.querySelector('.fit-finder-drawer__cta-button--add-cart');
      const formStep = drawer.querySelector('.fit-finder-drawer__step--form');
      const sizesStep = drawer.querySelector('.fit-finder-drawer__step--sizes');
      const resultsStep = drawer.querySelector('.fit-finder-drawer__step--results');
      const loadingEl = drawer.querySelector('.fit-finder-drawer__loading');
      const resultsContent = drawer.querySelector('.fit-finder-drawer__results-content');
      const resultsGrid = drawer.querySelector('.fit-finder-drawer__results-grid');
      const noMatchEl = drawer.querySelector('.fit-finder-drawer__no-match');
      const sizeButtons = drawer.querySelectorAll('.fit-finder-drawer__size-button');
      const backButton = drawer.querySelector('.fit-finder-drawer__back-button');
      const closeButton = drawer.querySelector('.fit-finder-drawer__close-button');
      
      // Get API settings from data attributes
      const apiBaseUrl = drawer.getAttribute('data-api-base-url') || '';
      const fitFinderApiEndpoint = drawer.getAttribute('data-api-endpoint') || '';
      const fitFinderApiUrl = apiBaseUrl + fitFinderApiEndpoint;
      
      let currentUnit = 'cm';
      let selectedSize = null;

      /**
       * Reset drawer to initial state
       * Called when drawer closes
       */
      function resetDrawer() {
        // Reset form input
        if (input) input.value = '';
        
        // Reset to form step (CSS handles inner elements)
        if (formStep) formStep.style.display = 'block';
        if (sizesStep) sizesStep.style.display = 'none';
        if (resultsStep) resultsStep.style.display = 'none';
        if (getSizeButton) {
          getSizeButton.style.display = 'flex';
          getSizeButton.disabled = true;
        }
        if (addCartButton) addCartButton.style.display = 'none';
        
        // Reset size selection
        sizeButtons.forEach(btn => btn.removeAttribute('data-selected'));
        selectedSize = null;
        if (addCartButton) addCartButton.disabled = true;
      }

      // Handle back button - go back to form step or close drawer
      function handleBackButtonClick(e) {
        const target = e.target.closest('.fit-finder-drawer__back-button');
        if (!target) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        // Find the drawer element (it might have been moved)
        const drawerElement = target.closest('#fit-finder-drawer') || document.getElementById('fit-finder-drawer');
        if (!drawerElement) return;
        
        // Check which step is currently visible
        const currentFormStep = drawerElement.querySelector('.fit-finder-drawer__step--form');
        const currentSizesStep = drawerElement.querySelector('.fit-finder-drawer__step--sizes');
        const currentResultsStep = drawerElement.querySelector('.fit-finder-drawer__step--results');
        
        // Check if results step is visible (including no-match state)
        const isResultsVisible = currentResultsStep && 
          (currentResultsStep.style.display === 'flex' || 
           currentResultsStep.style.display === 'block' ||
           !currentResultsStep.style.display || 
           window.getComputedStyle(currentResultsStep).display !== 'none');
        
        // Check if sizes step is visible
        const isSizesVisible = currentSizesStep && 
          (currentSizesStep.style.display === 'block' ||
           !currentSizesStep.style.display || 
           window.getComputedStyle(currentSizesStep).display !== 'none');
        
        // If on results or sizes step, go back to form
        if (isResultsVisible || isSizesVisible) {
          showFormStep();
        } else {
          // If on form step, close the drawer
          if (typeof drawerElement.closeDialog === 'function') {
            drawerElement.closeDialog();
          } else if (drawerElement.refs && drawerElement.refs.dialog) {
            drawerElement.refs.dialog.close();
          } else {
            const dialogEl = drawerElement.querySelector('dialog');
            if (dialogEl) {
              dialogEl.close();
            }
          }
        }
      }

      // Handle close button - always close the drawer
      function handleCloseButtonClick(e) {
        const target = e.target.closest('.fit-finder-drawer__close-button');
        if (!target) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        // Find the drawer element (it might have been moved)
        const drawerElement = target.closest('#fit-finder-drawer') || document.getElementById('fit-finder-drawer');
        if (!drawerElement) return;
        
        if (typeof drawerElement.closeDialog === 'function') {
          drawerElement.closeDialog();
        } else if (drawerElement.refs && drawerElement.refs.dialog) {
          drawerElement.refs.dialog.close();
        } else {
          const dialogEl = drawerElement.querySelector('dialog');
          if (dialogEl) {
            dialogEl.close();
          }
        }
      }

      // Use event delegation on document to catch clicks even after drawer is moved
      document.addEventListener('click', handleBackButtonClick, true);
      document.addEventListener('click', handleCloseButtonClick, true);

      // Also attach directly to buttons as fallback
      if (backButton) {
        backButton.addEventListener('click', handleBackButtonClick);
      }

      if (closeButton) {
        closeButton.addEventListener('click', handleCloseButtonClick);
      }

      /**
       * STEP 3: Checks localStorage and decides what to show
       * Called from: handleDrawerOpen()
       * 
       * Logic:
       * - If NOT a shoe product → show form
       * - If NO localStorage data → show form
       * - If HAS localStorage data → show results with saved size
       */
      function checkLocalStorageAndShowRecommendation() {
        // Check 1: Is this a shoe product?
        if (!isShoeProduct()) {
          showFormStep();
          return;
        }
        
        try {
          // Check 2: Do we have saved size data?
          const storedData = localStorage.getItem('tenXYouShoeSizeData');
          if (!storedData || storedData.trim() === '') {
            showFormStep();
            return;
          }
          
          // Check 3: Parse the data
          const sizeData = JSON.parse(storedData);
          
          // Check 4: Get product category (Cricket/Walking/Lifestyle)
          const category = getProductCategory();
          if (!category) {
            showFormStep();
            return;
          }
          
          // Check 5: Get size for this category
          const sizeValue = sizeData[category];
          if (!sizeValue || sizeValue.trim() === '') {
            showFormStep();
            return;
          }
          
          // Check 6: Verify that the size exists as a variant in the product
          if (typeof checkIfSizeExistsInVariants === 'function') {
            const sizeExists = checkIfSizeExistsInVariants(sizeValue.trim());
            if (!sizeExists) {
              // Size doesn't exist as a variant - show form and remove recommendation text
              if (typeof removeRecommendationText === 'function') {
                removeRecommendationText();
              }
              showFormStep();
              return;
            }
          }
          
          // Success: We have valid data AND size exists - show results
          showResultsStep(sizeValue.trim(), category);
          
        } catch (e) {
          showFormStep();
        }
      }
      
      /**
       * Helper: Get product category (Cricket/Walking/Lifestyle)
       * Returns: category string or null
       */
      function getProductCategory() {
        // Try metafield first
        let shoeType = getShoeTypeFromMetafield();
        if (shoeType) {
          const validCategories = ['Cricket shoes', 'Walking shoes', 'Lifestyle shoes'];
          const category = validCategories.find(cat => cat.toLowerCase() === shoeType.toLowerCase());
          if (category) return category;
        }
        
        // Fallback: Try product tags
        const productTagsScript = document.querySelector('script[type="application/json"][data-product-tags]');
          if (productTagsScript) {
            try {
            let productTags = JSON.parse(productTagsScript.textContent);
              if (typeof productTags === 'string') {
                productTags = productTags.split(',').map(tag => tag.trim()).filter(tag => tag);
              }
            return getShoeCategoryFromTags(productTags);
            } catch (e) {
            // Error parsing tags
          }
        }
        
        return null;
      }
      
      /**
       * STEP 4a: Shows results step with saved size
       * Called from: checkLocalStorageAndShowRecommendation() when localStorage has data
       * 
       * @param {string} sizeValue - The size to display (e.g., "9")
       * @param {string} category - The shoe category (e.g., "Cricket shoes")
       */
      function showResultsStep(sizeValue, category) {
        // First check if variant exists - if not, show form and remove recommendation text
        if (typeof checkIfSizeExistsInVariants === 'function' && sizeValue) {
          const sizeExists = checkIfSizeExistsInVariants(sizeValue.trim());
          if (!sizeExists) {
            // Size doesn't exist - remove recommendation text and show form
            if (typeof removeRecommendationText === 'function') {
              removeRecommendationText();
            }
            showFormStep();
            return;
          }
        }
        
        // Get elements
          const resultsSingle = drawer?.querySelector('.fit-finder-drawer__results-single');
          const sizeEl = resultsSingle?.querySelector('.fit-finder-drawer__result-size-value');
          const selectButton = resultsSingle?.querySelector('.fit-finder-drawer__select-size-button');
          
        // Safety check
          if (!resultsSingle || !sizeEl) {
            showFormStep();
            return;
          }
          
        // Show results step, hide others (CSS handles inner elements automatically)
        if (formStep) formStep.style.display = 'none';
        if (sizesStep) sizesStep.style.display = 'none';
        if (resultsStep) resultsStep.style.display = 'flex';
        
        // Hide the GET MY SIZE button when results are shown
        if (getSizeButton) {
          getSizeButton.style.display = 'none';
          getSizeButton.style.visibility = 'hidden';
        }
          
          // Update size text
        if (sizeEl && sizeValue) {
          sizeEl.textContent = sizeValue.trim() + ' US';
        }
          
        // Enable select button
          if (selectButton && category) {
            selectButton.style.display = 'block';
            selectButton.disabled = false;
            if (sizeValue) {
              selectButton.dataset.size = sizeValue.trim();
            }
            selectButton.dataset.category = category;
          }
          
        // Update recommendation text below "What's My Size" button
        // Use setTimeout to ensure variant picker is ready (especially in quick-add-modal)
        // Only show if variant exists (already checked above)
          if (typeof updateRecommendationText === 'function' && sizeValue && sizeValue.trim()) {
            try {
              // Call once - early exit in function will prevent unnecessary work
              updateRecommendationText(sizeValue.trim());
            } catch (e) {
              // Error updating recommendation text
            }
        }
      }
      
      /**
       * STEP 4b: Shows form step (default view)
       * Called from: checkLocalStorageAndShowRecommendation() when no localStorage data
       */
      function showFormStep() {
        // Show form step, hide others
        if (formStep) {
          formStep.style.display = 'block';
          formStep.style.removeProperty('visibility');
          formStep.style.removeProperty('opacity');
        }
        if (sizesStep) sizesStep.style.display = 'none';
        if (resultsStep) resultsStep.style.display = 'none';
        
        // Show the GET MY SIZE button (it's in the footer, always visible when form is shown)
        if (getSizeButton) {
          getSizeButton.style.display = 'flex';
          getSizeButton.style.removeProperty('visibility');
          
          // Check if input has valid text - enable button if it does
          if (input && input.value) {
            const numValue = parseFloat(input.value);
            getSizeButton.disabled = !(numValue && numValue > 0);
          } else {
            getSizeButton.disabled = true;
          }
        }
        
        // Focus on the input field when form is shown
        if (input) {
          // Use setTimeout to ensure the form is fully visible before focusing
          setTimeout(() => {
            input.focus();
          }, 100);
        }
      }

      
      // Reset when drawer closes
      drawer.addEventListener('dialog:close', resetDrawer);
      
      // Also listen on the dialog element itself
      if (dialog) {
        dialog.addEventListener('close', resetDrawer);
      }
      
      /**
       * STEP 2: Handles drawer open event
       * Called automatically when: drawer dialog opens (via event listener)
       * 
       * Flow:
       * 1. openFitFinderDrawer() opens the dialog
       * 2. Dialog fires 'dialog:open' or 'show' event
       * 3. This function runs automatically
       * 4. Hides all steps initially (prevents flash)
       * 5. Checks localStorage to decide what to show
       * 6. Shows either form (no data) or results (has data)
       */
      let isCheckingLocalStorage = false;
      function handleDrawerOpen() {
        // Prevent duplicate calls
        if (isCheckingLocalStorage) return;
        isCheckingLocalStorage = true;
        
        // Hide everything initially to prevent UI flash
        hideAllSteps();
        
        // Check localStorage and show appropriate view
        // Use requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
          checkLocalStorageAndShowRecommendation();
          // Reset flag after a short delay
            setTimeout(() => {
            isCheckingLocalStorage = false;
          }, 100);
        });
      }
      
      /**
       * Helper: Hide all drawer steps
       * Only controls parent containers - CSS handles children
       */
      function hideAllSteps() {
        if (formStep) formStep.style.display = 'none';
        if (sizesStep) sizesStep.style.display = 'none';
        if (resultsStep) resultsStep.style.display = 'none';
        if (getSizeButton) getSizeButton.style.display = 'none';
        if (addCartButton) addCartButton.style.display = 'none';
      }
      
      /**
       * Helper: Show form step with button
       */
      function showFormStepWithButton() {
        if (formStep) formStep.style.display = 'block';
          if (getSizeButton) {
          getSizeButton.style.display = 'flex';
            getSizeButton.disabled = true;
        }
      }
      
      drawer.addEventListener('dialog:open', handleDrawerOpen);
      if (dialog) {
        dialog.addEventListener('show', handleDrawerOpen);
        // Also check when dialog.open becomes true
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (dialog.hasAttribute('open') && dialog.open) {
                handleDrawerOpen();
              }
            }
          });
        });
        observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      
      // Store handleDrawerOpen on drawer element AND globally so openFitFinderDrawer can access it
      drawer._handleDrawerOpen = handleDrawerOpen;
      // Also store globally as fallback (in case drawer reference changes)
      if (typeof window !== 'undefined') {
        window._fitFinderHandleDrawerOpen = handleDrawerOpen;
      }

      // Handle unit toggle
      unitButtons.forEach(button => {
      button.addEventListener('click', () => {
        currentUnit = button.dataset.unit;
        unitButtons.forEach(btn => btn.classList.remove('fit-finder-drawer__unit-button--active'));
        button.classList.add('fit-finder-drawer__unit-button--active');
        
        // Update placeholder
        if (currentUnit === 'in') {
          input.placeholder = 'Enter your foot length (in inches)';
        } else {
          input.placeholder = 'Enter your foot length (in cm)';
        }
      });
    });

    // Restrict input to only digits and decimal point
    input.addEventListener('keydown', (e) => {
      const key = e.key;
      // Allow control keys (backspace, delete, tab, escape, enter, arrow keys, etc.)
      const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (controlKeys.includes(key) || e.ctrlKey || e.metaKey) {
        return; // Allow control keys
      }
      
      // Allow digits (0-9)
      if (/^[0-9]$/.test(key)) {
        return; // Allow digits
      }
      
      // Allow decimal point, but only one
      if (key === '.' || key === 'Decimal') {
        if (input.value.includes('.')) {
          e.preventDefault();
          return false;
        }
        return; // Allow decimal point if not already present
      }
      
      // Block all other keys
      e.preventDefault();
      return false;
    });

    // Handle paste event to filter invalid characters
    input.addEventListener('paste', (e) => {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      // Only allow digits and one decimal point
      const filtered = paste.replace(/[^0-9.]/g, '').replace(/\./g, (match, offset, string) => {
        // Only keep the first decimal point
        return string.indexOf('.') === offset ? '.' : '';
      });
      const currentValue = input.value;
      const selectionStart = input.selectionStart || 0;
      const selectionEnd = input.selectionEnd || 0;
      const newValue = currentValue.substring(0, selectionStart) + filtered + currentValue.substring(selectionEnd);
      input.value = newValue;
      input.dispatchEvent(new Event('input'));
    });

    // Handle input validation and enable/disable CTA button
    input.addEventListener('input', () => {
      
      const cursorPosition = input.selectionStart;
      
      // Filter out any invalid characters that might have been entered
      let value = input.value;
      // Remove any non-digit, non-decimal characters
      value = value.replace(/[^0-9.]/g, '');
      // Ensure only one decimal point
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }
      
      if (input.value !== value) {
      input.value = value;
        
        const newCursorPosition = Math.min(cursorPosition, value.length);
        input.setSelectionRange(newCursorPosition, newCursorPosition);
      }
      
      const numValue = parseFloat(value);
      if (numValue && numValue > 0) {
        getSizeButton.disabled = false;
      } else {
        getSizeButton.disabled = true;
      }
    });

    // Handle "GET MY TEN X YOU SIZE" button click
    getSizeButton.addEventListener('click', async () => {
      if (getSizeButton.disabled) return;
      
      const value = parseFloat(input.value);
      if (!value || value <= 0) return;
      
      // Show results step with loading
      formStep.style.display = 'none';
      resultsStep.style.display = 'block';
      loadingEl.style.display = 'flex';
      resultsContent.style.display = 'none';
      // Hide noMatchEl immediately when starting new search
      const allNoMatchEls = drawer.querySelectorAll('.fit-finder-drawer__no-match');
      allNoMatchEls.forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.visibility = 'hidden';
        el.classList.add('fit-finder-drawer__no-match--hidden');
      });
      // Also hide resultsSingle initially
      const resultsSingleInitial = drawer?.querySelector('.fit-finder-drawer__results-single');
      if (resultsSingleInitial) {
        resultsSingleInitial.style.display = 'none';
      }
      if (getSizeButton) {
      getSizeButton.style.setProperty('display', 'none', 'important');
      }
      
      try {
        // Get category from product metafield
        const category = (typeof getProductCategory === 'function') ? getProductCategory() : null;
        if (!category) {
          // No category found, show form again
          if (loadingEl) {
        loadingEl.style.display = 'none';
          }
          if (typeof showFormStep === 'function') {
            showFormStep();
          }
          return;
        }
        
        // Convert value to cm if unit is inches
        let sizeInCm = parseFloat(value);
        if (isNaN(sizeInCm)) {
          sizeInCm = 0;
        }
        if (currentUnit === 'in') {
          sizeInCm = sizeInCm * 2.54;
        }
        
        // Get country_code (default to US)
        const countryCode = 'US';
        
        // Build query params
        if (!fitFinderApiUrl) {
          if (loadingEl) {
            loadingEl.style.display = 'none';
          }
          if (typeof showFormStep === 'function') {
            showFormStep();
          }
          return;
        }
        
        const params = new URLSearchParams({
          country_code: countryCode || 'US',
          size_in_cm: (isNaN(sizeInCm) ? 0 : sizeInCm).toFixed(2),
          category: category || ''
        });
        
        // Make API call with query params (GET request)
        const apiUrlWithParams = `${fitFinderApiUrl}?${params.toString()}`;
        const response = await fetch(apiUrlWithParams, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        let data = null;
        if (response && response.ok) {
          try {
            data = await response.json();
              } catch (e) {
            // Invalid JSON response
            data = null;
          }
        }
        
        // Hide loading
        if (loadingEl) {
          loadingEl.style.display = 'none';
        }
        if (resultsContent) {
          resultsContent.style.display = 'block';
        }
        
        // Check if we have results
        // Response format: { "sizes": [ { "id": 14, "country_code": "US", "size": "5.5", "size_in_cm": "24.00" } ] }
        if (data && data.sizes && Array.isArray(data.sizes) && data.sizes.length > 0 && data.sizes[0]) {
          // Get size from response (first item's size)
          const sizeFromResponse = data.sizes[0]?.size || null;
          const sizeValue = (sizeFromResponse && typeof sizeFromResponse === 'string') ? sizeFromResponse : '';
          
          // Update localStorage (even if null/empty)
          if (category) {
            const sizeData = {
              [category]: sizeFromResponse || null
            };
            
            try {
              // Get existing data or create new
              const existingData = localStorage.getItem('tenXYouShoeSizeData');
              let storedData = {};
              if (existingData) {
                try {
                  storedData = JSON.parse(existingData);
                  if (!storedData || typeof storedData !== 'object') {
                    storedData = {};
                  }
                } catch (e) {
                  storedData = {};
                }
              }
              // Merge with new data (even if null)
              Object.assign(storedData, sizeData);
              localStorage.setItem('tenXYouShoeSizeData', JSON.stringify(storedData));
            } catch (e) {
              // localStorage might be disabled
            }
          }
          
          // Update single result display
          const resultsSingle = drawer?.querySelector('.fit-finder-drawer__results-single');
          const sizeEl = resultsSingle?.querySelector('.fit-finder-drawer__result-size-value');
          const selectButton = resultsSingle?.querySelector('.fit-finder-drawer__select-size-button');
          
          // Case 1: No data comes (size is empty/null)
          if (!sizeValue || (typeof sizeValue === 'string' && sizeValue.trim() === '')) {
            // Show "Unfortunately" message
            if (typeof showUnfortunatelyMessage === 'function') {
              showUnfortunatelyMessage();
            }
            return;
          }
          
          // Case 2: Check if the size exists as a variant in the product
          if (typeof checkIfSizeExistsInVariants === 'function') {
            const sizeExists = checkIfSizeExistsInVariants(sizeValue.trim());
            if (!sizeExists) {
              // Size doesn't exist as a variant - remove recommendation text and show "Unfortunately" message
              if (typeof removeRecommendationText === 'function') {
                removeRecommendationText();
              }
              if (typeof showUnfortunatelyMessage === 'function') {
                showUnfortunatelyMessage();
              }
            return;
            }
          }
          
          // Case 3: We have sizeValue AND it exists in variants - show recommendation
          // Hide button when showing results
          if (getSizeButton) {
            getSizeButton.style.setProperty('display', 'none', 'important');
          }
          
          // Ensure resultsContent is visible
          if (resultsContent) {
          resultsContent.removeAttribute('style');
          resultsContent.style.display = 'block';
          }
          
          // Hide ALL noMatch elements
          if (drawer) {
          const allNoMatchEls = drawer.querySelectorAll('.fit-finder-drawer__no-match');
            if (allNoMatchEls && allNoMatchEls.length > 0) {
          allNoMatchEls.forEach((el) => {
                if (el) {
            el.removeAttribute('style');
            el.style.setProperty('display', 'none', 'important');
            el.style.visibility = 'hidden';
                }
          });
            }
          }
          
          // Show resultsSingle
          if (resultsSingle && sizeEl) {
            // Update size text
            if (typeof sizeValue === 'string' && sizeValue.trim()) {
            sizeEl.textContent = sizeValue.trim() + ' US';
            }
            
            // Show resultsSingle
            resultsSingle.removeAttribute('style');
            resultsSingle.style.setProperty('display', 'flex', 'important');
            resultsSingle.style.visibility = 'visible';
            
            // Show and configure select button
            if (selectButton && category) {
              selectButton.removeAttribute('style');
              selectButton.style.display = 'block';
              selectButton.dataset.category = category;
              if (typeof sizeValue === 'string' && sizeValue.trim()) {
                selectButton.dataset.size = sizeValue.trim();
              }
            }
            
            // Show resultsStep
            if (formStep) formStep.style.display = 'none';
            if (sizesStep) sizesStep.style.display = 'none';
            if (resultsStep) {
              resultsStep.removeAttribute('style');
              resultsStep.style.display = 'block';
            }
            
            // Update recommendation text (if function exists)
            // This will update "What's My Size" on both quick-add modal and PDP page
            if (typeof updateRecommendationText === 'function' && typeof sizeValue === 'string' && sizeValue.trim()) {
              try {
                updateRecommendationText(sizeValue.trim());
              } catch (e) {
                // Error updating recommendation text
              }
            }
          }
        } else {
          // No data in response (sizes array is empty or doesn't exist)
          // Update localStorage with null
          if (category) {
            const sizeData = {
              [category]: null
            };
            
            try {
              // Get existing data or create new
              const existingData = localStorage.getItem('tenXYouShoeSizeData');
              let storedData = {};
              if (existingData) {
                try {
                  storedData = JSON.parse(existingData);
                  if (!storedData || typeof storedData !== 'object') {
                    storedData = {};
                  }
                } catch (e) {
                  storedData = {};
                }
              }
              // Merge with new data (null value)
              Object.assign(storedData, sizeData);
              localStorage.setItem('tenXYouShoeSizeData', JSON.stringify(storedData));
            } catch (e) {
              // localStorage might be disabled
            }
          }
          
          // Show "Unfortunately" message
          if (typeof showUnfortunatelyMessage === 'function') {
            showUnfortunatelyMessage();
          }
        }
      } catch (error) {
        // Error occurred - update localStorage with null
        if (category) {
          const sizeData = {
            [category]: null
          };
          
          try {
            // Get existing data or create new
            const existingData = localStorage.getItem('tenXYouShoeSizeData');
            let storedData = {};
            if (existingData) {
              try {
                storedData = JSON.parse(existingData);
                if (!storedData || typeof storedData !== 'object') {
                  storedData = {};
                }
              } catch (e) {
                storedData = {};
              }
            }
            // Merge with new data (null value)
            Object.assign(storedData, sizeData);
            localStorage.setItem('tenXYouShoeSizeData', JSON.stringify(storedData));
          } catch (e) {
            // localStorage might be disabled
          }
        }
        
        // Show "Unfortunately" message
        if (typeof showUnfortunatelyMessage === 'function') {
          showUnfortunatelyMessage();
        }
      }
    });
    
    /**
     * Helper function to show "Unfortunately" message
     * Called from: getSizeButton click handler when API returns no data or error
     */
    function showUnfortunatelyMessage() {
      // Hide loading
      if (loadingEl) loadingEl.style.display = 'none';
      
      // Remove recommendation text since there's no data
        if (typeof removeRecommendationText === 'function') {
          removeRecommendationText();
        }
        
        // Show resultsStep
        if (formStep) formStep.style.display = 'none';
        if (sizesStep) sizesStep.style.display = 'none';
        if (resultsStep) {
          resultsStep.removeAttribute('style');
        resultsStep.style.display = 'block';
        }
            if (getSizeButton) getSizeButton.style.setProperty('display', 'none', 'important');
        
      // Ensure resultsContent is visible
        resultsContent.removeAttribute('style');
        resultsContent.style.display = 'block';
        
        // Hide resultsSingle
        const resultsSingle = drawer.querySelector('.fit-finder-drawer__results-single');
        if (resultsSingle) {
          resultsSingle.removeAttribute('style');
          resultsSingle.style.setProperty('display', 'none', 'important');
        }
        
        // Show noMatchEl
        const allNoMatchEls = drawer.querySelectorAll('.fit-finder-drawer__no-match');
        allNoMatchEls.forEach((el) => {
          el.removeAttribute('style');
          el.style.setProperty('display', 'flex', 'important');
          el.style.visibility = 'visible';
          el.style.opacity = '1';
        el.classList.remove('fit-finder-drawer__no-match--hidden');
        });
      
      // Force a reflow to ensure styles are applied
      void resultsStep?.offsetHeight;
      }

    // Handle size selection
    sizeButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove previous selection
        sizeButtons.forEach(btn => {
          btn.removeAttribute('data-selected');
        });
        
        // Set new selection
        button.setAttribute('data-selected', 'true');
        selectedSize = button.dataset.size;
        addCartButton.disabled = false;
      });
    });

    // Handle "Add to cart" button click
    if (addCartButton) {
      addCartButton.addEventListener('click', async () => {
        if (!addCartButton || addCartButton.disabled || !selectedSize) return;
        
        // Disable button during request
        addCartButton.disabled = true;
        
        try {
          // Find variant picker and get variant ID for selected size
          const variantPicker = document.querySelector('variant-picker');
          let variantId = null;
          
          if (variantPicker) {
            // Find the size option that matches selectedSize
            let sizeOption = variantPicker.querySelector(`input[data-option-value-id*="${selectedSize}"], button[data-option-value-id*="${selectedSize}"]`);
            
            if (!sizeOption) {
              // Try to find by text content
              const allOptions = variantPicker.querySelectorAll('input[type="radio"], button');
              if (allOptions && allOptions.length > 0) {
                for (const option of allOptions) {
                  if (!option) continue;
                  const optionText = option.textContent?.trim() || option.value?.trim();
                  if (optionText === selectedSize || optionText === `${selectedSize} US` || optionText === `US ${selectedSize}`) {
                    sizeOption = option;
                    break;
                  }
                }
              }
            }
            
            if (sizeOption) {
              variantId = sizeOption.dataset?.variantId || sizeOption.getAttribute('data-variant-id');
            }
          }
          
          // Fallback: Try to get variant ID from product form
          if (!variantId) {
            const productForm = document.querySelector('product-form-component form');
            if (productForm) {
              const variantIdInput = productForm.querySelector('input[name="id"][ref="variantId"]');
              if (variantIdInput && variantIdInput.value) {
                variantId = variantIdInput.value;
              }
            }
          }
          
          if (!variantId) {
            if (addCartButton) addCartButton.disabled = false;
            return;
          }
          
          // Get cart add URL - try Theme.routes first, then form action, then default
          let cartAddUrl = '/cart/add.js';
          if (typeof Theme !== 'undefined' && Theme.routes?.cart_add_url) {
            cartAddUrl = Theme.routes.cart_add_url;
          } else {
            // Try to get from product form
            const productForm = document.querySelector('product-form-component form');
            if (productForm && productForm.action) {
              cartAddUrl = productForm.action;
            }
          }
          
          // Get cart items components for sections update
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          const cartItemComponentsSectionIds = [];
          if (cartItemsComponents && cartItemsComponents.length > 0) {
            cartItemsComponents.forEach((item) => {
              if (item instanceof HTMLElement && item.dataset?.sectionId) {
                cartItemComponentsSectionIds.push(item.dataset.sectionId);
              }
            });
          }
          
          // Create form data
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          if (cartItemComponentsSectionIds.length > 0) {
            formData.append('sections', cartItemComponentsSectionIds.join(','));
          }
          
          // Make fetch request - match product-form.js pattern
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'text/html',
            },
            body: formData,
          });
          
          if (!response || !response.ok) {
            throw new Error(`HTTP error! status: ${response?.status || 'unknown'}`);
          }
          
          let result = null;
          try {
            result = await response.json();
          } catch (jsonError) {
            throw new Error('Invalid response from server');
          }
          
          if (!result) {
            throw new Error('Empty response from server');
          }
          
          if (result.status) {
            // Error occurred
            // Dispatch cart error event (matches CartErrorEvent structure)
            const errorEvent = new CustomEvent('cart:error', {
              bubbles: true,
              detail: {
                sourceId: drawer?.id || 'fit-finder-drawer',
                data: {
                  message: result.message || 'Failed to add item to cart',
                  description: result.description || null,
                  errors: result.errors || null,
                },
              },
            });
            document.dispatchEvent(errorEvent);
            
            if (addCartButton) addCartButton.disabled = false;
          } else {
            // Success - dispatch cart update event (matches CartAddEvent structure)
            const addEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: result || {},
                sourceId: drawer?.id || 'fit-finder-drawer',
                data: {
                  source: 'fit-finder-drawer',
                  itemCount: 1,
                  variantId: variantId,
                  sections: result?.sections || {},
                },
              },
            });
            document.dispatchEvent(addEvent);
            
            // Close drawer after successful add
            if (drawer) {
              if (typeof drawer.closeDialog === 'function') {
        drawer.closeDialog();
              } else if (drawer.refs && drawer.refs.dialog) {
                drawer.refs.dialog.close();
              } else {
                const dialogEl = drawer.querySelector('dialog');
                if (dialogEl) {
                  dialogEl.close();
                }
              }
            }
          }
        } catch (error) {
          if (addCartButton) addCartButton.disabled = false;
        }
      });
    }

    // Function to remove recommendation text when there's no data
    function removeRecommendationText() {
      // Find all variant pickers (PDP and quick add modal)
      const variantPickers = document.querySelectorAll('variant-picker');
      
      variantPickers.forEach(variantPicker => {
        // Find the "What's My Size" button in this variant picker
        const whatsMySizeButton = variantPicker.querySelector('.what-my-size-wrapper.fit-finder-trigger');
        if (whatsMySizeButton) {
          // Find the legend element
          const legend = whatsMySizeButton.closest('legend.legend-container');
          if (legend) {
            // Find the recommendation container div
            const recommendationContainer = legend.querySelector('.legend-container__recommendation');
            if (recommendationContainer) {
              // Find and remove recommendation text if it exists
              const recommendationText = recommendationContainer.querySelector('.fit-finder-recommendation-text');
              if (recommendationText) {
                recommendationText.remove();
              }
            }
          }
        }
      });
    }
    
    // Expose function globally
    if (typeof window !== 'undefined') {
      window.removeRecommendationText = removeRecommendationText;
    }

    // Function to update recommendation text dynamically
    // Add processing flag to prevent concurrent executions
    let isUpdatingRecommendation = false;
    
    // Cache for SVG icon content to prevent re-fetching
    let cachedSvgIcon = null;
    let svgIconFetching = false;
    
    function updateRecommendationText(size) {
      if (!size || size.trim() === '') {
        // If size is empty, remove recommendation text
        removeRecommendationText();
        return;
      }
      
      // Check if variant exists - if not, don't show recommendation text
      if (typeof checkIfSizeExistsInVariants === 'function') {
        const sizeExists = checkIfSizeExistsInVariants(size.trim());
        if (!sizeExists) {
          // Variant doesn't exist - remove recommendation text
          removeRecommendationText();
          return;
        }
      }
      
      // Prevent concurrent executions
      if (isUpdatingRecommendation) {
        return;
      }
      
      const sizeStr = String(size).trim();
      const expectedText = `Fit finder recommends ${sizeStr} US based on your foot length.`;
      
      // ULTRA EARLY EXIT: Quick check - if any existing content has wrong text, we need update
      // Check first variant picker found - if it's correct, likely all are correct
      const firstVariantPicker = document.querySelector('variant-picker');
      if (firstVariantPicker) {
        const firstContent = firstVariantPicker.querySelector('.fit-finder-recommendation-text__content');
        if (firstContent && firstContent.textContent.trim() === expectedText.trim()) {
          // First one is correct, check all to be sure
          const variantPickers = document.querySelectorAll('variant-picker');
          let allCorrect = true;
          for (const vp of variantPickers) {
            const existingContent = vp.querySelector('.fit-finder-recommendation-text__content');
            if (!existingContent || existingContent.textContent.trim() !== expectedText.trim()) {
              allCorrect = false;
              break;
            }
          }
          if (allCorrect) {
            return; // All already correct, exit immediately - no DOM manipulation
          }
        }
      }
      
      isUpdatingRecommendation = true;
      
      // Get all variant pickers for processing
      const variantPickers = document.querySelectorAll('variant-picker');
      
      variantPickers.forEach(variantPicker => {
        // Skip if this variant picker already has correct text AND icon exists
        const existingContent = variantPicker.querySelector('.fit-finder-recommendation-text__content');
        const existingIcon = variantPicker.querySelector('.fit-finder-recommendation-text__icon');
        if (existingContent && existingContent.textContent.trim() === expectedText.trim() && existingIcon && existingIcon.innerHTML.trim() !== '') {
          return; // Skip this variant picker, text and icon are already correct
        }
        // Find the "What's My Size" button in this variant picker
        const whatsMySizeButton = variantPicker.querySelector('.what-my-size-wrapper.fit-finder-trigger');
        if (whatsMySizeButton) {
          // Find the legend element - try multiple methods for quick-add-modal
          let legend = whatsMySizeButton.closest('legend.legend-container');
          
          // If not found, try finding by looking for the recommendation container's parent
          if (!legend) {
            // Try to find legend that contains recommendation container
            const existingContainer = variantPicker.querySelector('.legend-container__recommendation');
            if (existingContainer) {
              legend = existingContainer.closest('legend.legend-container');
            }
          }
          
          // If still not found, try to find any legend in the variant picker
          if (!legend) {
            legend = variantPicker.querySelector('legend.legend-container');
          }
          
          if (legend) {
            // Find the recommendation container div
            let recommendationContainer = legend.querySelector('.legend-container__recommendation');
            
            // If not found, create it (for quick-add-modal where it might not exist yet)
            if (!recommendationContainer) {
              recommendationContainer = document.createElement('div');
              recommendationContainer.className = 'legend-container__recommendation';
              legend.appendChild(recommendationContainer);
            }
            
            if (recommendationContainer) {
              // Check if recommendation text already exists
              let recommendationText = recommendationContainer.querySelector('.fit-finder-recommendation-text');
              
              // Check if icon already exists (to prevent re-fetching/re-rendering)
              let existingIcon = null;
              if (recommendationText) {
                existingIcon = recommendationText.querySelector('.fit-finder-recommendation-text__icon');
              }
              
              if (!recommendationText) {
                recommendationText = document.createElement('div');
                recommendationText.className = 'fit-finder-recommendation-text';
                
                // Get tape-measure icon URL from data attribute
                const drawer = document.getElementById('fit-finder-drawer');
                const tapeMeasureUrl = drawer?.getAttribute('data-tape-measure-icon-url') || '';
                
                // Create icon container
                const iconContainer = document.createElement('span');
                iconContainer.className = 'fit-finder-recommendation-text__icon';
                
                // Use cached SVG or fetch and cache it
                const fallbackSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33325 6.65292C3.33325 7.39692 4.52659 8.00025 5.99992 8.00025V6.65292C5.99992 5.99025 5.99992 5.65825 5.73525 5.45625C5.46992 5.25425 5.20725 5.32958 4.68192 5.48092C3.87659 5.71358 3.33325 6.15025 3.33325 6.65292Z" stroke="#1646C8" stroke-linejoin="round"/>
<path d="M10.6666 5.66683C10.6666 6.9555 8.57725 8.00016 5.99992 8.00016C3.42259 8.00016 1.33325 6.9555 1.33325 5.66683C1.33325 4.37816 3.42259 3.3335 5.99992 3.3335C8.57725 3.3335 10.6666 4.37816 10.6666 5.66683Z" stroke="#1646C8"/>
<path d="M1.33325 6V10.4447C1.33325 11.6713 3.42259 12.6667 5.99992 12.6667H13.3333C13.9619 12.6667 14.2759 12.6667 14.4713 12.4713C14.6666 12.276 14.6666 11.962 14.6666 11.3333V9.33333C14.6666 8.70467 14.6666 8.39067 14.4713 8.19533C14.2759 8 13.9619 8 13.3333 8H5.99992" stroke="#1646C8"/>
<path d="M12 12.6667V11.3333M9.33333 12.6667V11.3333M6.66667 12.6667V11.3333M4 12.3333V11" stroke="#1646C8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                
                if (cachedSvgIcon) {
                  // Use cached SVG immediately - no fetch needed
                  iconContainer.innerHTML = cachedSvgIcon;
                } else if (tapeMeasureUrl && !svgIconFetching) {
                  // Fetch and cache SVG
                  svgIconFetching = true;
                  fetch(tapeMeasureUrl)
                    .then(response => response.text())
                    .then(svgContent => {
                      cachedSvgIcon = svgContent; // Cache it
                      svgIconFetching = false;
                      // Only set if icon container still exists and is empty
                      if (iconContainer && iconContainer.innerHTML.trim() === '') {
                        iconContainer.innerHTML = svgContent;
                      }
                    })
                    .catch(() => {
                      // Fallback: use inline SVG if fetch fails
                      cachedSvgIcon = fallbackSvg; // Cache fallback
                      svgIconFetching = false;
                      if (iconContainer && iconContainer.innerHTML.trim() === '') {
                        iconContainer.innerHTML = fallbackSvg;
                      }
                    });
                } else {
                  // Use fallback SVG if no URL or already fetching
                  if (iconContainer.innerHTML.trim() === '') {
                    iconContainer.innerHTML = fallbackSvg;
                  }
                }
                
                // Create content span
                const contentSpan = document.createElement('span');
                contentSpan.className = 'fit-finder-recommendation-text__content';
                contentSpan.textContent = `Fit finder recommends ${sizeStr} US based on your foot length.`;

                
                // Append elements
                recommendationText.appendChild(iconContainer);
                recommendationText.appendChild(contentSpan);
                
                // Insert into the recommendation container
                recommendationContainer.appendChild(recommendationText);
              } else {
                // Update existing text only if it has changed
                const contentEl = recommendationText.querySelector('.fit-finder-recommendation-text__content');
                if (contentEl) {
                  // Only update if text actually changed (prevent flickering/re-renders)
                  if (contentEl.textContent.trim() !== expectedText.trim()) {
                    contentEl.textContent = expectedText;
                  }
                }
                
                // Ensure icon exists - if it was removed, restore it (but don't re-fetch if it already exists)
                if (!existingIcon || !recommendationText.querySelector('.fit-finder-recommendation-text__icon')) {
                  // Icon was removed, restore it
                  const drawer = document.getElementById('fit-finder-drawer');
                  const tapeMeasureUrl = drawer?.getAttribute('data-tape-measure-icon-url') || '';
                  
                  const iconContainer = document.createElement('span');
                  iconContainer.className = 'fit-finder-recommendation-text__icon';
                  
                  // Insert icon before content
                  const contentEl = recommendationText.querySelector('.fit-finder-recommendation-text__content');
                  if (contentEl) {
                    recommendationText.insertBefore(iconContainer, contentEl);
                  } else {
                    recommendationText.appendChild(iconContainer);
                  }
                  
                  // Use cached SVG or fetch and cache it
                  const fallbackSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33325 6.65292C3.33325 7.39692 4.52659 8.00025 5.99992 8.00025V6.65292C5.99992 5.99025 5.99992 5.65825 5.73525 5.45625C5.46992 5.25425 5.20725 5.32958 4.68192 5.48092C3.87659 5.71358 3.33325 6.15025 3.33325 6.65292Z" stroke="#1646C8" stroke-linejoin="round"/>
<path d="M10.6666 5.66683C10.6666 6.9555 8.57725 8.00016 5.99992 8.00016C3.42259 8.00016 1.33325 6.9555 1.33325 5.66683C1.33325 4.37816 3.42259 3.3335 5.99992 3.3335C8.57725 3.3335 10.6666 4.37816 10.6666 5.66683Z" stroke="#1646C8"/>
<path d="M1.33325 6V10.4447C1.33325 11.6713 3.42259 12.6667 5.99992 12.6667H13.3333C13.9619 12.6667 14.2759 12.6667 14.4713 12.4713C14.6666 12.276 14.6666 11.962 14.6666 11.3333V9.33333C14.6666 8.70467 14.6666 8.39067 14.4713 8.19533C14.2759 8 13.9619 8 13.3333 8H5.99992" stroke="#1646C8"/>
<path d="M12 12.6667V11.3333M9.33333 12.6667V11.3333M6.66667 12.6667V11.3333M4 12.3333V11" stroke="#1646C8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                  
                  if (cachedSvgIcon) {
                    // Use cached SVG immediately - no fetch needed
                    iconContainer.innerHTML = cachedSvgIcon;
                  } else if (tapeMeasureUrl && !svgIconFetching) {
                    // Fetch and cache SVG
                    svgIconFetching = true;
                    fetch(tapeMeasureUrl)
                      .then(response => response.text())
                      .then(svgContent => {
                        cachedSvgIcon = svgContent; // Cache it
                        svgIconFetching = false;
                        iconContainer.innerHTML = svgContent;
                      })
                      .catch(() => {
                        // Fallback: use inline SVG if fetch fails
                        cachedSvgIcon = fallbackSvg; // Cache fallback
                        svgIconFetching = false;
                        iconContainer.innerHTML = fallbackSvg;
                      });
                  } else {
                    // Use fallback SVG if no URL or already fetching
                    iconContainer.innerHTML = fallbackSvg;
                  }
                }
                // If icon already exists, do nothing - don't touch it to prevent re-rendering
              }
            }
          }
        }
      });
      
      // Reset processing flag
      isUpdatingRecommendation = false;
    }
    
    // Expose function globally
    if (typeof window !== 'undefined') {
      window.updateRecommendationText = updateRecommendationText;
    }
    

    // Handle "SELECT THIS SIZE & FIT" button clicks
    const selectSizeButtons = drawer?.querySelectorAll('.fit-finder-drawer__select-size-button');
    if (selectSizeButtons && selectSizeButtons.length > 0) {
    selectSizeButtons.forEach(button => {
        if (!button) return;
        
      button.addEventListener('click', () => {
          if (!button || button.disabled) return;
        
          const size = button.dataset?.size;
        if (!size) return;
        
        const sizeStr = String(size).trim();
          if (!sizeStr) return;
          
        const normalizedSize = sizeStr.replace(/\s*US\s*/gi, '').trim();
        
        // Find variant picker - check in quick add modal first, then document
        let variantPicker = null;
        
        // Check quick add modal first
        const quickAddModal = document.querySelector('#quick-add-dialog dialog[open], .quick-add-modal[open], #quick-add-dialog[open]');
        if (quickAddModal) {
          variantPicker = quickAddModal.querySelector('variant-picker');
        }
        
        // If not found, check in document
        if (!variantPicker) {
          variantPicker = document.querySelector('variant-picker');
        }
        
          if (!variantPicker) {
            // Close drawer even if variant picker not found
            if (drawer) {
              if (drawer.closeDialog) {
                drawer.closeDialog();
              } else if (drawer.refs && drawer.refs.dialog) {
                drawer.refs.dialog.close();
              } else {
                const dialogEl = drawer.querySelector('dialog');
                if (dialogEl) {
                  dialogEl.close();
                }
              }
            }
            return;
          }
          
          // First, find the size fieldset (the one with "What's My Size" button)
          const sizeFieldset = variantPicker.querySelector('fieldset.variant-option:has(.what-my-size-wrapper.fit-finder-trigger)');
          
          // If fieldset not found with :has(), try alternative method
          let sizeFieldsetAlt = null;
          if (!sizeFieldset) {
            const allFieldsets = variantPicker.querySelectorAll('fieldset.variant-option');
            if (allFieldsets && allFieldsets.length > 0) {
              for (const fieldset of allFieldsets) {
                if (!fieldset) continue;
                const hasFitFinder = fieldset.querySelector('.what-my-size-wrapper.fit-finder-trigger');
                if (hasFitFinder) {
                  sizeFieldsetAlt = fieldset;
                  break;
                }
              }
            }
          }
          
          const targetFieldset = sizeFieldset || sizeFieldsetAlt;
          
          // Find the size option within the size fieldset
          let sizeOption = null;
          
          // Get all options - prioritize options within the size fieldset
          const searchScope = targetFieldset || variantPicker;
          if (!searchScope) return;
          
          const allInputs = searchScope.querySelectorAll('input[type="radio"]');
          const allButtons = searchScope.querySelectorAll('button');
          const allOptions = [...(allInputs || []), ...(allButtons || [])];
          
          if (!allOptions || allOptions.length === 0) {
            // Close drawer if no options found
            if (drawer) {
              if (drawer.closeDialog) {
                drawer.closeDialog();
              } else if (drawer.refs && drawer.refs.dialog) {
                drawer.refs.dialog.close();
              } else {
                const dialogEl = drawer.querySelector('dialog');
                if (dialogEl) {
                  dialogEl.close();
                }
              }
            }
            return;
          }
          
          for (const option of allOptions) {
            if (!option) continue;
            
            // Skip if option is not in the size fieldset (if we found one)
            if (targetFieldset && !targetFieldset.contains(option)) {
              continue;
            }
            
            // Check value attribute
            const optionValue = option.value?.trim() || option.getAttribute('value')?.trim() || '';
            const normalizedOptionValue = optionValue.replace(/\s*US\s*/gi, '').trim();
            
            // Check text content (for buttons)
            const optionText = option.textContent?.trim() || '';
            const normalizedOptionText = optionText.replace(/\s*US\s*/gi, '').trim();
            
            // Check label text (for inputs)
            let labelText = '';
            if (option instanceof HTMLInputElement) {
              const label = option.closest('label');
              if (label) {
                const labelTextEl = label.querySelector('.variant-option__button-label__text');
                if (labelTextEl) {
                  labelText = labelTextEl.textContent?.trim() || '';
                } else {
                  labelText = label.textContent?.trim() || '';
                }
              }
            }
            const normalizedLabelText = labelText.replace(/\s*US\s*/gi, '').trim();
            
            // Match check - try exact match, normalized match, and numeric match
            const matches = 
              optionValue === sizeStr ||
              optionValue === `${sizeStr} US` ||
              optionValue === `US ${sizeStr}` ||
              normalizedOptionValue === normalizedSize ||
              optionText === sizeStr ||
              optionText === `${sizeStr} US` ||
              optionText === `US ${sizeStr}` ||
              normalizedOptionText === normalizedSize ||
              labelText === sizeStr ||
              labelText === `${sizeStr} US` ||
              labelText === `US ${sizeStr}` ||
              normalizedLabelText === normalizedSize;
            
            // Also try numeric comparison
            const sizeNum = parseFloat(normalizedSize);
            if (!matches && !isNaN(sizeNum)) {
              const optionNum = parseFloat(normalizedOptionValue) || parseFloat(normalizedOptionText) || parseFloat(normalizedLabelText);
              if (!isNaN(optionNum) && optionNum === sizeNum) {
                sizeOption = option;
                break;
              }
            } else if (matches) {
              sizeOption = option;
              break;
            }
          }
          
          // If found, select it (only if available)
          if (sizeOption) {
            // Check if size is available (not disabled)
            const isAvailable = !sizeOption.disabled && 
                               sizeOption.getAttribute('aria-disabled') !== 'true' &&
                               sizeOption.dataset?.optionAvailable !== 'false';
            
            if (isAvailable) {
            // Store the size value to restore recommendation text after variant update
            const sizeToRestore = sizeStr;
            
            // Listen for variant update events to restore recommendation text
            const restoreRecommendationText = () => {
              // Use setTimeout to ensure variant picker has finished updating
              setTimeout(() => {
                if (typeof updateRecommendationText === 'function') {
                  updateRecommendationText(sizeToRestore);
                }
                // Remove listener after restoring
                document.removeEventListener('variant:update', restoreRecommendationText);
              }, 100);
            };
            
            // Listen for variant update event
            document.addEventListener('variant:update', restoreRecommendationText, { once: true });
            
            if (sizeOption instanceof HTMLInputElement) {
                if (sizeOption) {
                sizeOption.checked = true;
                sizeOption.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else if (sizeOption instanceof HTMLButtonElement) {
                if (sizeOption) {
              sizeOption.click();
                }
            }
            
            // Also restore after a delay as fallback
            setTimeout(() => {
              if (typeof updateRecommendationText === 'function') {
                updateRecommendationText(sizeToRestore);
              }
            }, 300);
            } else {
              // Size exists but is not available - show message or do nothing
              console.log('Size is not available:', sizeStr);
          }
        }
        
        // Close drawer
          if (drawer) {
        if (drawer.closeDialog) {
          drawer.closeDialog();
        } else if (drawer.refs && drawer.refs.dialog) {
          drawer.refs.dialog.close();
        } else {
          const dialogEl = drawer.querySelector('dialog');
          if (dialogEl) {
            dialogEl.close();
              }
          }
        }
      });
    });
    }

    // Handle "Find another size" button click
    const findAnotherSizeButtons = drawer.querySelectorAll('.fit-finder-drawer__find-another-size-button');
    findAnotherSizeButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Reset form and show form step
        resetDrawer();
        showFormStep();
      });
    });

    // Handle "EXPLORE SIZE CHART" button click in no-match section
    const exploreSizeChartButton = drawer.querySelector('.fit-finder-drawer__explore-size-chart-button');
    if (exploreSizeChartButton) {
      exploreSizeChartButton.addEventListener('click', () => {
        // Get shoe type from metafield
        const shoeTypeScript = document.querySelector('script[type="application/json"][data-shoe-type-metafield]');
        let shoeType = null;
        
        if (shoeTypeScript) {
          try {
            shoeType = JSON.parse(shoeTypeScript.textContent);
            if (typeof shoeType === 'string') {
              shoeType = shoeType.trim();
            }
          } catch (e) {
            const shoeTypeString = shoeTypeScript.textContent.trim();
            if (shoeTypeString) {
              shoeType = shoeTypeString;
            }
          }
        }
        
        // Close fit finder drawer first
        if (drawer.closeDialog) {
          drawer.closeDialog();
        } else if (drawer.refs && drawer.refs.dialog) {
          drawer.refs.dialog.close();
        } else {
          const dialogEl = drawer.querySelector('dialog');
          if (dialogEl) {
            dialogEl.close();
          }
        }
        
        // Open size chart drawer
        if (typeof window.openSizeChartDrawer === 'function') {
          setTimeout(() => {
            window.openSizeChartDrawer(shoeType);
          }, 300);
        }
      });
    }


    // Utility function to get shoe category from product tags (fallback)
    function getShoeCategoryFromTags(productTags) {
      if (!productTags || !Array.isArray(productTags)) return null;
      
      const tags = productTags.map(tag => tag.toLowerCase());
      
      if (tags.some(tag => tag.includes('cricket'))) {
        return 'Cricket shoes';
      } else if (tags.some(tag => tag.includes('walking'))) {
        return 'Walking shoes';
      } else if (tags.some(tag => tag.includes('lifestyle'))) {
        return 'Lifestyle shoes';
      }
      
      return null;
    }

    // Function to check if a size exists in product variants (regardless of availability)
    function checkIfSizeExistsInVariants(size) {
      if (!size || size.trim() === '') {
        return false;
      }
      
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) {
        return false;
      }
      
      const normalizedSize = size.replace(/\s*US\s*/gi, '').trim();
      const sizeToMatch = size.trim();
      
      // Check all size options (both inputs and selects)
      const allInputs = variantPicker.querySelectorAll('input[type="radio"][data-option-value-id]');
      const allSelects = variantPicker.querySelectorAll('select');
      
      // If no inputs or selects found, variant picker might not be fully loaded
      if (allInputs.length === 0 && allSelects.length === 0) {
        return false;
      }
      
      // Check radio inputs first
      for (const input of allInputs) {
        if (!input) continue;
        
        // Check input value attribute directly
        const inputValue = input.value?.trim() || input.getAttribute('value')?.trim() || '';
        const normalizedInputValue = inputValue.replace(/\s*US\s*/gi, '').trim();
        
        // Also check the label text content (the visible size text)
        const label = input.closest('label');
        const labelText = label?.querySelector('.variant-option__button-label__text')?.textContent?.trim() || '';
        const normalizedLabelText = labelText.replace(/\s*US\s*/gi, '').trim();
        
        // Check all divs inside variant-option__button-label (first and last, and all divs)
        const buttonLabel = label?.querySelector('.variant-option__button-label');
        let firstDivValue = '';
        let lastDivValue = '';
        let allDivValues = [];
        
        if (buttonLabel) {
          const divs = buttonLabel.querySelectorAll('div');
          if (divs.length > 0) {
            // Get first div value (textContent or value attribute)
            firstDivValue = divs[0]?.textContent?.trim() || divs[0]?.getAttribute('value')?.trim() || divs[0]?.innerText?.trim() || '';
            // Get last div value
            lastDivValue = divs[divs.length - 1]?.textContent?.trim() || divs[divs.length - 1]?.getAttribute('value')?.trim() || divs[divs.length - 1]?.innerText?.trim() || '';
            // Get all div values
            divs.forEach(div => {
              const divVal = div.textContent?.trim() || div.getAttribute('value')?.trim() || div.innerText?.trim() || '';
              if (divVal) allDivValues.push(divVal);
            });
          }
        }
        
        const normalizedFirstDiv = firstDivValue.replace(/\s*US\s*/gi, '').trim();
        const normalizedLastDiv = lastDivValue.replace(/\s*US\s*/gi, '').trim();
        const normalizedAllDivs = allDivValues.map(v => v.replace(/\s*US\s*/gi, '').trim());
        
        // Match size (check value, normalized value, label text, normalized label text, and all div values)
        // Also try numeric comparison for sizes like "9" vs "9.0"
        let sizeMatches = inputValue === sizeToMatch || 
                           inputValue === `${sizeToMatch} US` || 
                           inputValue === `US ${sizeToMatch}` ||
                           normalizedInputValue === normalizedSize ||
                           normalizedInputValue === sizeToMatch ||
                           labelText === sizeToMatch ||
                           labelText === `${sizeToMatch} US` ||
                           labelText === `US ${sizeToMatch}` ||
                           normalizedLabelText === normalizedSize ||
                           normalizedLabelText === sizeToMatch ||
                           firstDivValue === sizeToMatch ||
                           firstDivValue === `${sizeToMatch} US` ||
                           firstDivValue === `US ${sizeToMatch}` ||
                           normalizedFirstDiv === normalizedSize ||
                           normalizedFirstDiv === sizeToMatch ||
                           lastDivValue === sizeToMatch ||
                           lastDivValue === `${sizeToMatch} US` ||
                           lastDivValue === `US ${sizeToMatch}` ||
                           normalizedLastDiv === normalizedSize ||
                           normalizedLastDiv === sizeToMatch;
        
        // Check all div values
        if (!sizeMatches && allDivValues.length > 0) {
          sizeMatches = allDivValues.some(divVal => {
            const normalizedDivVal = divVal.replace(/\s*US\s*/gi, '').trim();
            return divVal === sizeToMatch ||
                   divVal === `${sizeToMatch} US` ||
                   divVal === `US ${sizeToMatch}` ||
                   normalizedDivVal === normalizedSize ||
                   normalizedDivVal === sizeToMatch;
          });
        }
        
        // Try numeric comparison for all values
        if (!sizeMatches && normalizedSize) {
          const sizeNum = parseFloat(normalizedSize);
          if (!isNaN(sizeNum)) {
            sizeMatches = (normalizedInputValue && parseFloat(normalizedInputValue) === sizeNum) ||
                         (normalizedLabelText && parseFloat(normalizedLabelText) === sizeNum) ||
                         (normalizedFirstDiv && parseFloat(normalizedFirstDiv) === sizeNum) ||
                         (normalizedLastDiv && parseFloat(normalizedLastDiv) === sizeNum) ||
                         normalizedAllDivs.some(divVal => {
                           const divNum = parseFloat(divVal);
                           return !isNaN(divNum) && divNum === sizeNum;
                         });
          }
        }
        
        if (sizeMatches) {
          return true; // Size exists in variants
        }
      }
      
      // Check select dropdowns
      for (const select of allSelects) {
        if (!select) continue;
        for (const option of select.options) {
          if (!option) continue;
          const optionValue = option.value?.trim() || '';
          const normalizedOptionValue = optionValue.replace(/\s*US\s*/gi, '').trim();
          const optionText = option.textContent?.trim() || '';
          const normalizedOptionText = optionText.replace(/\s*US\s*/gi, '').trim();
          
          if (optionValue === sizeToMatch || 
              optionValue === `${sizeToMatch} US` || 
              optionValue === `US ${sizeToMatch}` ||
              normalizedOptionValue === normalizedSize ||
              normalizedOptionValue === sizeToMatch ||
              optionText === sizeToMatch ||
              optionText === `${sizeToMatch} US` ||
              optionText === `US ${sizeToMatch}` ||
              normalizedOptionText === normalizedSize ||
              normalizedOptionText === sizeToMatch ||
              (normalizedOptionValue && normalizedSize && parseFloat(normalizedOptionValue) === parseFloat(normalizedSize)) ||
              (normalizedOptionText && normalizedSize && parseFloat(normalizedOptionText) === parseFloat(normalizedSize))) {
            return true; // Size exists in variants
          }
        }
      }
      
      // If size not found in variants, return false (size doesn't exist for this product)
      return false;
    }

    // Function to check if a size is available in product variants (not sold out)
    function checkIfSizeAvailable(size) {
      if (!size || size.trim() === '') return false;
      
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) {
        // If variant picker not found, assume size might be available (don't block)
        return true;
      }
      
      const normalizedSize = size.replace(/\s*US\s*/gi, '').trim();
      
      // Check all size options (both inputs and selects)
      const allInputs = variantPicker.querySelectorAll('input[type="radio"][data-option-value-id]');
      const allSelects = variantPicker.querySelectorAll('select');
      
      // Check radio inputs first
      for (const input of allInputs) {
        if (!input) continue;
        
        const inputValue = input.value?.trim() || '';
        const normalizedInputValue = inputValue.replace(/\s*US\s*/gi, '').trim();
        
        // Match size first (regardless of availability)
        const sizeMatches = inputValue === size || 
                           inputValue === `${size} US` || 
                           inputValue === `US ${size}` ||
                           normalizedInputValue === normalizedSize ||
                           normalizedInputValue === size;
        
        if (sizeMatches) {
          // Check if option is available (not disabled/sold out)
          const isAvailable = input.dataset.optionAvailable !== 'false' && 
                             !input.hasAttribute('aria-disabled') &&
                             input.getAttribute('aria-disabled') !== 'true' &&
                             !input.disabled;
          
          return isAvailable;
        }
      }
      
      // Check select dropdowns
      for (const select of allSelects) {
        if (!select) continue;
        for (const option of select.options) {
          if (!option) continue;
          const optionValue = option.value?.trim() || '';
          const normalizedOptionValue = optionValue.replace(/\s*US\s*/gi, '').trim();
          
          if (optionValue === size || 
              optionValue === `${size} US` || 
              optionValue === `US ${size}` ||
              normalizedOptionValue === normalizedSize ||
              normalizedOptionValue === size) {
            // For selects, if option exists, consider it available
            return true;
          }
        }
      }
      
      // If size not found in variants, return false (size doesn't exist for this product)
      return false;
    }

    // Function to get shoe type from metafield
    function getShoeTypeFromMetafield() {
      const shoeTypeScript = document.querySelector('script[type="application/json"][data-shoe-type-metafield]');
      if (!shoeTypeScript) return null;
      
      try {
        let shoeType = JSON.parse(shoeTypeScript.textContent);
        if (typeof shoeType === 'string') {
          shoeType = shoeType.trim();
        }
        return shoeType || null;
      } catch (e) {
        const shoeTypeString = shoeTypeScript.textContent.trim();
        return shoeTypeString || null;
      }
    }

    // Function to check localStorage and show size below "What's My Size" button
    function checkAndDisplaySize() {
      // Only show size if it's a shoe product
      if (typeof isShoeProduct !== 'function' || !isShoeProduct()) {
        return;
      }
      
      try {
        const storedData = localStorage.getItem('tenXYouShoeSizeData');
        if (!storedData || storedData.trim() === '') return;
        
        let sizeData = null;
        try {
          sizeData = JSON.parse(storedData);
          if (!sizeData || typeof sizeData !== 'object') {
            return;
          }
        } catch (e) {
          // Invalid JSON
          return;
        }
        
        // Get product tags from the page
        const productTagsScript = document.querySelector('script[type="application/json"][data-product-tags]');
        let productTags = null;
        
        if (productTagsScript && productTagsScript.textContent) {
          try {
            productTags = JSON.parse(productTagsScript.textContent);
            // If it's a string (comma-separated), convert to array
            if (typeof productTags === 'string') {
              productTags = productTags.split(',').map(tag => tag.trim()).filter(tag => tag);
            }
          } catch (e) {
            // Parse error, try as string
            const tagString = productTagsScript.textContent?.trim();
            if (tagString) {
              productTags = tagString.split(',').map(tag => tag.trim()).filter(tag => tag);
            }
          }
        }
        
        // Get shoe type from metafield first, then fallback to tags
        let shoeType = null;
        if (typeof getShoeTypeFromMetafield === 'function') {
          shoeType = getShoeTypeFromMetafield();
        }
        let category = null;
        
        if (shoeType && typeof shoeType === 'string') {
          // Check if it matches one of the expected categories
          const validCategories = ['Cricket shoes', 'Walking shoes', 'Lifestyle shoes'];
          category = validCategories.find(cat => cat.toLowerCase() === shoeType.toLowerCase()) || null;
        }
        
        // Fallback to tags if metafield doesn't match
        if (!category && productTags && typeof getShoeCategoryFromTags === 'function') {
          category = getShoeCategoryFromTags(productTags);
        }
        
        if (!category || typeof category !== 'string') return;
        
        const size = sizeData[category];
        if (!size || typeof size !== 'string' || size.trim() === '') return;
        
        // Check if variant exists - if not, don't show recommendation text
        if (typeof checkIfSizeExistsInVariants === 'function') {
          const sizeExists = checkIfSizeExistsInVariants(size.trim());
          if (!sizeExists) {
            // Variant doesn't exist - remove any existing recommendation text and return
            if (typeof removeRecommendationText === 'function') {
              removeRecommendationText();
            }
            return;
          }
        }
        
        // Find the shoe size fieldset and add recommendation text in legend container
        const whatsMySizeButton = document.querySelector('.what-my-size-wrapper.fit-finder-trigger');
        if (whatsMySizeButton) {
          // Find the legend element
          const legend = whatsMySizeButton.closest('legend.legend-container');
          if (legend) {
            // Find the recommendation container div
            const recommendationContainer = legend.querySelector('.legend-container__recommendation');
            if (recommendationContainer) {
              // Check if recommendation text already exists
              let recommendationText = recommendationContainer.querySelector('.fit-finder-recommendation-text');
              
              if (!recommendationText) {
                recommendationText = document.createElement('div');
                recommendationText.className = 'fit-finder-recommendation-text';
                
                // Get tape-measure icon URL from data attribute
                const drawer = document.getElementById('fit-finder-drawer');
                const tapeMeasureUrl = drawer?.getAttribute('data-tape-measure-icon-url') || '';
                
                // Create icon container
                const iconContainer = document.createElement('span');
                iconContainer.className = 'fit-finder-recommendation-text__icon';
                
                // Fetch and insert SVG
                if (tapeMeasureUrl) {
                  fetch(tapeMeasureUrl)
                    .then(response => response.text())
                    .then(svgContent => {
                      iconContainer.innerHTML = svgContent;
                    })
                    .catch(() => {
                      // Fallback: use inline SVG if fetch fails
                      iconContainer.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33325 6.65292C3.33325 7.39692 4.52659 8.00025 5.99992 8.00025V6.65292C5.99992 5.99025 5.99992 5.65825 5.73525 5.45625C5.46992 5.25425 5.20725 5.32958 4.68192 5.48092C3.87659 5.71358 3.33325 6.15025 3.33325 6.65292Z" stroke="#1646C8" stroke-linejoin="round"/>
<path d="M10.6666 5.66683C10.6666 6.9555 8.57725 8.00016 5.99992 8.00016C3.42259 8.00016 1.33325 6.9555 1.33325 5.66683C1.33325 4.37816 3.42259 3.3335 5.99992 3.3335C8.57725 3.3335 10.6666 4.37816 10.6666 5.66683Z" stroke="#1646C8"/>
<path d="M1.33325 6V10.4447C1.33325 11.6713 3.42259 12.6667 5.99992 12.6667H13.3333C13.9619 12.6667 14.2759 12.6667 14.4713 12.4713C14.6666 12.276 14.6666 11.962 14.6666 11.3333V9.33333C14.6666 8.70467 14.6666 8.39067 14.4713 8.19533C14.2759 8 13.9619 8 13.3333 8H5.99992" stroke="#1646C8"/>
<path d="M12 12.6667V11.3333M9.33333 12.6667V11.3333M6.66667 12.6667V11.3333M4 12.3333V11" stroke="#1646C8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                    });
                } else {
                  // Fallback: use inline SVG if URL not available
                  iconContainer.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33325 6.65292C3.33325 7.39692 4.52659 8.00025 5.99992 8.00025V6.65292C5.99992 5.99025 5.99992 5.65825 5.73525 5.45625C5.46992 5.25425 5.20725 5.32958 4.68192 5.48092C3.87659 5.71358 3.33325 6.15025 3.33325 6.65292Z" stroke="#1646C8" stroke-linejoin="round"/>
<path d="M10.6666 5.66683C10.6666 6.9555 8.57725 8.00016 5.99992 8.00016C3.42259 8.00016 1.33325 6.9555 1.33325 5.66683C1.33325 4.37816 3.42259 3.3335 5.99992 3.3335C8.57725 3.3335 10.6666 4.37816 10.6666 5.66683Z" stroke="#1646C8"/>
<path d="M1.33325 6V10.4447C1.33325 11.6713 3.42259 12.6667 5.99992 12.6667H13.3333C13.9619 12.6667 14.2759 12.6667 14.4713 12.4713C14.6666 12.276 14.6666 11.962 14.6666 11.3333V9.33333C14.6666 8.70467 14.6666 8.39067 14.4713 8.19533C14.2759 8 13.9619 8 13.3333 8H5.99992" stroke="#1646C8"/>
<path d="M12 12.6667V11.3333M9.33333 12.6667V11.3333M6.66667 12.6667V11.3333M4 12.3333V11" stroke="#1646C8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                }
                
                // Create content span
                const contentSpan = document.createElement('span');
                if (contentSpan) {
                  contentSpan.className = 'fit-finder-recommendation-text__content';
                  if (size && typeof size === 'string' && size.trim()) {
                    contentSpan.textContent = `Fit finder recommends ${size.trim()} US based on your foot length.`;
                  }
                  
                  // Append elements
                  if (iconContainer) {
                    recommendationText.appendChild(iconContainer);
                  }
                  recommendationText.appendChild(contentSpan);
                  
                  // Insert into the recommendation container
                  if (recommendationContainer) {
                    recommendationContainer.appendChild(recommendationText);
                  }
                }
              } else {
                // Update existing text
                const contentEl = recommendationText?.querySelector('.fit-finder-recommendation-text__content');
                if (contentEl && size && typeof size === 'string' && size.trim()) {
                  contentEl.textContent = `Fit finder recommends ${size.trim()} US based on your foot length.`;
                }
              }
            }
          }
        }
      } catch (e) {
        // Error reading localStorage or parsing
      }
    }

    // Check and display size on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkAndDisplaySize);
    } else {
      checkAndDisplaySize();
    }
    
    // Listen for quick-add-modal opening to show recommendation text
    // This is needed because modal content loads dynamically
    function handleQuickAddModalOpen() {
      // Wait a bit for modal content to load
      setTimeout(() => {
        // Check if modal is open
        const quickAddModal = document.querySelector('#quick-add-dialog dialog[open], .quick-add-modal[open], #quick-add-dialog[open]');
        if (!quickAddModal) return;
        
        // Check if it's a shoe product in the modal
        const variantPicker = quickAddModal.querySelector('variant-picker');
        if (!variantPicker) return;
        
        const shoeTypeScript = variantPicker.querySelector('script[type="application/json"][data-shoe-type-metafield]');
        if (!shoeTypeScript) return;
        
        // Get size from localStorage
        try {
          const storedData = localStorage.getItem('tenXYouShoeSizeData');
          if (!storedData) return;
          
          const sizeData = JSON.parse(storedData);
          
          // Get shoe type and category
          let shoeType = null;
          try {
            shoeType = JSON.parse(shoeTypeScript.textContent);
            if (typeof shoeType === 'string') {
              shoeType = shoeType.trim();
            }
          } catch (e) {
            shoeType = shoeTypeScript.textContent.trim();
          }
          
          if (!shoeType) return;
          
          const validCategories = ['Cricket shoes', 'Walking shoes', 'Lifestyle shoes'];
          const category = validCategories.find(cat => cat.toLowerCase() === shoeType.toLowerCase());
          if (!category) return;
          
          const sizeValue = sizeData[category];
          if (!sizeValue || sizeValue.trim() === '') return;
          
          // Call updateRecommendationText to show the recommendation
          if (typeof updateRecommendationText === 'function') {
            // Call once - early exit in function will prevent unnecessary work
            updateRecommendationText(sizeValue.trim());
          }
        } catch (e) {
          // Error - ignore
        }
      }, 100);
    }
    
    // Listen for quick-add-modal dialog open events
    const quickAddDialog = document.getElementById('quick-add-dialog');
    if (quickAddDialog) {
      const quickAddModalDialog = quickAddDialog.querySelector('dialog');
      if (quickAddModalDialog) {
        // Listen for dialog open
        quickAddModalDialog.addEventListener('show', handleQuickAddModalOpen);
        
        // Also use MutationObserver to watch for open attribute
        const modalObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (quickAddModalDialog.hasAttribute('open') && quickAddModalDialog.open) {
                handleQuickAddModalOpen();
              }
            }
          });
        });
        modalObserver.observe(quickAddModalDialog, { attributes: true, attributeFilter: ['open'] });
      }
    }
    
    // Also listen for dialog:open event if the component fires it
    if (quickAddDialog) {
      quickAddDialog.addEventListener('dialog:open', handleQuickAddModalOpen);
    }
    
    // Listen for variant update events to restore recommendation text
    // This ensures the recommendation text persists after variant picker updates
    let variantUpdateTimeout = null;
    document.addEventListener('variant:update', () => {
      // Clear any pending timeout
      if (variantUpdateTimeout) {
        clearTimeout(variantUpdateTimeout);
        variantUpdateTimeout = null;
      }
      
      // Get the current size from localStorage
      try {
        const storedData = localStorage.getItem('tenXYouShoeSizeData');
        if (!storedData) return;
        
        const sizeData = JSON.parse(storedData);
        
        // Get product category to find the right size
        let variantPicker = null;
        const quickAddModal = document.querySelector('#quick-add-dialog dialog[open], .quick-add-modal[open], #quick-add-dialog[open]');
        if (quickAddModal) {
          variantPicker = quickAddModal.querySelector('variant-picker');
        }
        if (!variantPicker) {
          variantPicker = document.querySelector('variant-picker');
        }
        
        if (!variantPicker) return;
        
        // EARLY EXIT: Check if this is even a shoe product
        const shoeTypeScript = variantPicker.querySelector('script[type="application/json"][data-shoe-type-metafield]');
        if (!shoeTypeScript) return; // Not a shoe product, exit immediately
        
        // Get shoe type from variant picker
        let shoeType = null;
        try {
          shoeType = JSON.parse(shoeTypeScript.textContent);
          if (typeof shoeType === 'string') {
            shoeType = shoeType.trim();
          }
        } catch (e) {
          const shoeTypeString = shoeTypeScript.textContent.trim();
          shoeType = shoeTypeString || null;
        }
        
        if (!shoeType) return;
        
        // Get category
        const validCategories = ['Cricket shoes', 'Walking shoes', 'Lifestyle shoes'];
        const category = validCategories.find(cat => cat.toLowerCase() === shoeType.toLowerCase()) || null;
        
        if (!category) return;
        
        const sizeValue = sizeData[category];
        if (!sizeValue) return;
        
        const sizeValueStr = String(sizeValue).trim();
        if (!sizeValueStr || sizeValueStr === '') return;
        
        const expectedText = `Fit finder recommends ${sizeValueStr} US based on your foot length.`;
        
        // ULTRA EARLY EXIT: Check if recommendation text already exists with correct content
        // Do this BEFORE setTimeout to prevent any unnecessary work
        const allVariantPickers = document.querySelectorAll('variant-picker');
        let allCorrect = true;
        let needsRestore = false;
        
        for (const vp of allVariantPickers) {
          const existingContent = vp.querySelector('.fit-finder-recommendation-text__content');
          const recommendationContainer = vp.querySelector('.legend-container__recommendation');
          
          // If container exists but text is missing, it was removed - needs restore
          if (recommendationContainer && !existingContent) {
            needsRestore = true;
            allCorrect = false;
            break;
          }
          
          // If text exists but is wrong, needs update
          if (existingContent && existingContent.textContent.trim() !== expectedText.trim()) {
            allCorrect = false;
            break;
          }
          
          // If text exists and is correct, this one is good
          if (existingContent && existingContent.textContent.trim() === expectedText.trim()) {
            // This one is correct, continue checking others
            continue;
          }
        }
        
        // If all variant pickers already have correct text, don't do anything
        if (allCorrect && !needsRestore) {
          return; // Exit immediately, no setTimeout, no function calls
        }
        
        // If text was removed (container exists but text missing), restore immediately
        if (needsRestore && typeof updateRecommendationText === 'function') {
          // Use requestAnimationFrame for smooth restoration without flickering
          requestAnimationFrame(() => {
            updateRecommendationText(sizeValueStr);
          });
          return; // Exit after scheduling restore
        }
        
        // Restore recommendation text after a delay to ensure variant picker has updated
        variantUpdateTimeout = setTimeout(() => {
          // Double-check after delay (variant picker might have re-rendered)
          let needsUpdate = false;
          for (const vp of allVariantPickers) {
            const existingContent = vp.querySelector('.fit-finder-recommendation-text__content');
            if (!existingContent || existingContent.textContent.trim() !== expectedText.trim()) {
              needsUpdate = true;
              break;
            }
          }
          
          // Only call function if update is actually needed
          if (needsUpdate && typeof updateRecommendationText === 'function') {
            updateRecommendationText(sizeValueStr);
          }
          variantUpdateTimeout = null;
        }, 200);
      } catch (e) {
        // Error - ignore
      }
    });

    // Flag to track if we intercepted an add to cart click
    let interceptedAddToCart = false;

    // Check if product is a shoe (has shoe_type_for_fit_finder metafield)
    function isShoeProduct() {
      const shoeTypeScript = document.querySelector('script[type="application/json"][data-shoe-type-metafield]');
      if (!shoeTypeScript) return false;
      
      try {
        let shoeType = JSON.parse(shoeTypeScript.textContent);
        if (typeof shoeType === 'string') {
          shoeType = shoeType.trim();
        }
        // If metafield has a value, it's a shoe
        return shoeType && shoeType !== '' && shoeType !== null && shoeType !== undefined;
      } catch (e) {
        const shoeTypeString = shoeTypeScript.textContent.trim();
        return shoeTypeString && shoeTypeString !== '';
      }
    }

    // Handle variant size button clicks - open fit finder drawer on first click
    function handleVariantSizeClick(e) {
      // Check if the clicked element is a variant size radio input or label containing one
      let sizeInput = e.target.closest('input[type="radio"]');
      
      // If clicked on label, find the input inside
      if (!sizeInput) {
        const label = e.target.closest('label.variant-option__button-label');
        if (label) {
          sizeInput = label.querySelector('input[type="radio"]');
        }
      }
      
      if (!sizeInput) return;
      
      // Check if it's inside a variant picker
      const variantPicker = sizeInput.closest('variant-picker');
      if (!variantPicker) return;
      
      // Check if it's a shoe product
      if (!isShoeProduct()) return;
      
      // Check if this is the "Shoe size" option by checking the fieldset
      const fieldset = sizeInput.closest('fieldset.variant-option');
      if (!fieldset) return;
      
      // Check if this fieldset has the "What's My Size" button (indicates it's the Shoe size option)
      const hasFitFinderTrigger = fieldset.querySelector('.what-my-size-wrapper.fit-finder-trigger');
      if (!hasFitFinderTrigger) return;
      
      // Check if drawer has already been opened (stored in localStorage)
      try {
        const isDrawerOpen = localStorage.getItem('is_drawer_open');
        
        // Only open drawer if it hasn't been opened before
        if (!isDrawerOpen || isDrawerOpen !== 'true') {
          // Open fit finder drawer
          requestAnimationFrame(() => {
            openFitFinderDrawer();
          });
          
          // Store flag in localStorage
          localStorage.setItem('is_drawer_open', 'true');
        }
      } catch (err) {
        // If localStorage fails, allow normal behavior
        console.error('Error accessing localStorage:', err);
      }
    }

    // Intercept add to cart button clicks - use capture phase to run first
    function interceptAddToCartClick(e) {
      // Check multiple selectors to catch all add to cart buttons
      const addToCartButton = e.target.closest(
        'button[name="add"], ' +
        'button[type="submit"][name="add"], ' +
        'add-to-cart-component button, ' +
        '.quick-add__button, ' +
        'button.quick-add__button--add, ' +
        'button.quick-add__button--choose'
      );
      
      if (!addToCartButton) {
        interceptedAddToCart = false;
        return;
      }
      
      // Only intercept if it's a shoe product
      if (!isShoeProduct()) {
        interceptedAddToCart = false;
        return;
      }
      
      // Check if it's from quick add modal (already open) or quick add component (on product card)
      const isInQuickAddModal = addToCartButton.closest('.quick-add-modal, #quick-add-dialog');
      const isQuickAddComponent = addToCartButton.closest('quick-add-component, .quick-add') && !isInQuickAddModal;
      
      // Check if we have size data in localStorage
      try {
        const storedData = localStorage.getItem('tenXYouShoeSizeData');
        
        // If it's a quick add component button (on product card), allow it to open the modal first
        if (isQuickAddComponent && !isInQuickAddModal) {
          // Don't intercept - let quick add modal open first
          interceptedAddToCart = false;
          return;
        }
        
        // Don't intercept add to cart - allow normal behavior
        interceptedAddToCart = false;
      } catch (err) {
        interceptedAddToCart = false;
        // Error, allow normal add to cart
      }
    }

    // Intercept form submissions - use capture phase to run first
    function interceptAddToCartSubmit(e) {
      const form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      
      // Check if it's an add to cart form
      const isAddToCartForm = form.querySelector('input[name="id"]') && 
                              (form.dataset.type === 'add-to-cart-form' || 
                               form.querySelector('button[name="add"]') ||
                               form.querySelector('add-to-cart-component'));
      
      if (!isAddToCartForm) return;
      
      // Only intercept if it's a shoe product
      if (!isShoeProduct()) {
        return;
      }
      
      // Check if it's from quick add modal (already open) or quick add component (on product card)
      const isInQuickAddModal = form.closest('.quick-add-modal, #quick-add-dialog');
      const isQuickAddComponent = form.closest('quick-add-component, .quick-add') && !isInQuickAddModal;
      
      // Check if we have size data in localStorage
      try {
        const storedData = localStorage.getItem('tenXYouShoeSizeData');
        
        // If it's a quick add component form (on product card), allow it to open the modal first
        if (isQuickAddComponent && !isInQuickAddModal) {
          // Don't intercept - let quick add modal open first
          return;
        }
        
        // Don't intercept add to cart - allow normal behavior
      } catch (err) {
        // Error, allow normal add to cart
      }
    }

    // Add event listeners for add to cart interception
    document.addEventListener('click', interceptAddToCartClick, true);
    document.addEventListener('submit', interceptAddToCartSubmit, true);
    
    // Add event listener for variant size button clicks
    document.addEventListener('click', handleVariantSizeClick, true);
    
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fit-finder-find-my-size"] && !Shopify.designMode) return;
  try {
    (function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFindMySizeModal);
    } else {
      initFindMySizeModal();
    }

    function initFindMySizeModal() {
      const helpLink = document.getElementById('where-can-i-see-foot-length-link');
      const findMySizeModal = document.getElementById('fit-finder-find-my-size-modal');
      
      if (!helpLink || !findMySizeModal) return;

      helpLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const modalDialog = findMySizeModal.querySelector('dialog');
        if (modalDialog) {
          customElements.whenDefined('dialog-component').then(() => {
            if (typeof findMySizeModal.showDialog === 'function') {
              findMySizeModal.showDialog();
            } else if (findMySizeModal.refs && findMySizeModal.refs.dialog) {
              findMySizeModal.refs.dialog.showModal();
              findMySizeModal.refs.dialog.setAttribute('open', '');
            } else {
              modalDialog.showModal();
              modalDialog.setAttribute('open', '');
              modalDialog.style.display = 'flex';
              modalDialog.style.zIndex = '10001';
            }
          });
        }
      });

      const closeBtn = findMySizeModal.querySelector('.fit-finder-find-my-size-modal__close-button');
      const modalDialog = findMySizeModal.querySelector('dialog');
      
      if (closeBtn && modalDialog) {
        closeBtn.addEventListener('click', () => {
          if (findMySizeModal.closeDialog) {
            findMySizeModal.closeDialog();
          } else {
            modalDialog.close();
            modalDialog.removeAttribute('open');
            modalDialog.style.display = 'none';
          }
        });
      }

      if (modalDialog) {
        modalDialog.addEventListener('click', (e) => {
          if (e.target === modalDialog) {
            if (findMySizeModal.closeDialog) {
              findMySizeModal.closeDialog();
            } else {
              modalDialog.close();
              modalDialog.removeAttribute('open');
              modalDialog.style.display = 'none';
            }
          }
        });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fit-finder-size-chart"] && !Shopify.designMode) return;
  try {
    (function() {
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeChartDrawer);
    } else {
      initSizeChartDrawer();
    }

    /**
     * Initializes the size chart drawer
     * Sets up event listeners and helper functions
     */
    function initSizeChartDrawer() {
      const drawer = document.getElementById('fit-finder-size-chart-drawer');
      if (!drawer) return;

      const dialog = drawer.querySelector('dialog');
      if (!dialog) return;

      /**
       * Closes the drawer
       */
      function closeDrawer() {
        // Don't close if currently rendering
        if (drawer.dataset.rendering === 'true') {
          return;
        }

        // Close using available method
        if (typeof drawer.closeDialog === 'function') {
          drawer.closeDialog();
        } else if (drawer.refs?.dialog) {
          drawer.refs.dialog.close();
        } else if (dialog) {
          dialog.close();
          dialog.style.display = 'none';
        }

        // Clear flags
        delete drawer.dataset.opening;
        window._sizeChartOpening = false;
      }

      /**
       * Handles close button clicks (back/close buttons)
       */
      function handleCloseClick(e) {
        const button = e.target.closest('.fit-finder-size-chart-drawer__close-button');
        if (!button || !drawer.contains(button)) return;

        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }

      /**
       * Handles backdrop clicks (clicking outside drawer)
       */
      function handleBackdropClick(e) {
        const openDialog = drawer.querySelector('dialog[open]');
        if (!openDialog || e.target !== openDialog) return;

        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }

      // Setup event listeners using event delegation
      if (!document.sizeChartCloseListenerAdded) {
        document.addEventListener('click', handleCloseClick, true);
        document.sizeChartCloseListenerAdded = true;
      }

      if (!document.sizeChartBackdropListenerAdded) {
        document.addEventListener('click', handleBackdropClick, true);
        document.sizeChartBackdropListenerAdded = true;
      }

      /**
       * Handles unit toggle (CM/Inches)
       */
      function handleUnitToggle(e) {
        const button = e.target.closest('.fit-finder-size-chart-drawer__unit-button');
        if (!button) return;

        const unit = button.dataset.unit;
        const container = button.closest('.fit-finder-size-chart-drawer__table-wrapper') || drawer;

        // Update active button
        container.querySelectorAll('.fit-finder-size-chart-drawer__unit-button').forEach(btn => {
          btn.classList.toggle('fit-finder-size-chart-drawer__unit-button--active', btn === button);
        });

        // Update table container
        const tableContainer = container.querySelector('.fit-finder-size-chart-drawer__table-container');
        if (tableContainer) {
          tableContainer.dataset.unit = unit;
        }

        // Toggle unit text and values
        container.querySelectorAll('.fit-finder-size-chart-drawer__unit-text, .fit-finder-size-chart-drawer__unit-value').forEach(el => {
          el.style.display = el.dataset.unit === unit ? 'inline' : 'none';
        });
      }

      // Setup unit toggle using event delegation
      if (!document.sizeChartUnitToggleListenerAdded) {
        document.addEventListener('click', handleUnitToggle, true);
        document.sizeChartUnitToggleListenerAdded = true;
      }

      /**
       * Helper: Get shoe type from metafield
       */
      function getShoeType() {
        // Try quick add modal first
        const quickAddModal = document.querySelector('#quick-add-dialog dialog[open], .quick-add-modal[open]');
        let variantPicker = quickAddModal?.querySelector('variant-picker');
        
        // Fallback: search all variant pickers
        if (!variantPicker) {
          variantPicker = document.querySelector('variant-picker');
        }
        
        if (!variantPicker) return null;
        
        const shoeTypeScript = variantPicker.querySelector('script[type="application/json"][data-shoe-type-metafield]');
        if (!shoeTypeScript) return null;
        
        try {
          const parsed = JSON.parse(shoeTypeScript.textContent);
          if (typeof parsed === 'string' && parsed.trim() !== '' && parsed !== 'null') {
            return parsed.trim();
          }
          return parsed ? String(parsed).trim() : null;
        } catch (e) {
          const str = shoeTypeScript.textContent.trim();
          return str && str !== 'null' && str !== '""' ? str.replace(/^["']|["']$/g, '').trim() : null;
        }
      }

      /**
       * Helper: Get size chart data script
       */
      function getSizeChartDataScript() {
        let script = drawer.nextElementSibling;
        if (script && script.hasAttribute('data-size-chart-data')) {
          return script;
        }
        
        script = document.querySelector('script[type="application/json"][data-size-chart-data]');
        if (script && script.previousElementSibling !== drawer) {
          script.remove();
          if (drawer.nextSibling) {
            drawer.parentElement.insertBefore(script, drawer.nextSibling);
          } else {
            drawer.parentElement.appendChild(script);
          }
        }
        return script;
      }

      /**
       * Loads and renders the size chart table
       * @param {string} providedShoeType - Optional shoe type (Cricket/Walking/Lifestyle)
       */
      function loadAndRenderSizeChart(providedShoeType) {
        if (!drawer) return;

        // Prevent multiple simultaneous renders
        if (drawer.dataset.rendering === 'true') return;
        drawer.dataset.rendering = 'true';

        const dialog = drawer.querySelector('dialog');
        if (!dialog) {
          delete drawer.dataset.rendering;
          return;
        }

        // Ensure dialog is open
        dialog.setAttribute('open', '');
        dialog.style.display = 'flex';

        // Move to body if needed
        if (drawer.parentElement !== document.body) {
          const sizeChartDataScript = drawer.nextElementSibling;
          if (sizeChartDataScript?.hasAttribute('data-size-chart-data')) {
            document.body.appendChild(sizeChartDataScript);
          }
          document.body.appendChild(drawer);
        }

        // Get shoe type
        let shoeType = providedShoeType || drawer.dataset.shoeType || getShoeType();
        if (!shoeType || shoeType === 'null' || shoeType === '') {
          delete drawer.dataset.rendering;
          return;
        }

        // Get size chart data
        const sizeChartDataScript = getSizeChartDataScript();
        if (!sizeChartDataScript) {
          delete drawer.dataset.rendering;
          return;
        }

        // Parse size chart data
        let sizeChartData = null;
        let sizeChartTitle2 = null;
        try {
          const parsed = JSON.parse(sizeChartDataScript.textContent);
          if (Array.isArray(parsed)) {
            sizeChartData = parsed;
          } else if (parsed.data && Array.isArray(parsed.data)) {
            sizeChartData = parsed.data;
            sizeChartTitle2 = parsed.title_2 || null;
          } else {
            sizeChartData = parsed;
          }
        } catch (e) {
          delete drawer.dataset.rendering;
          return;
        }

        if (!sizeChartData || !Array.isArray(sizeChartData)) {
          delete drawer.dataset.rendering;
          return;
        }

        // Find matching category
        const shoeTypeLower = shoeType.toLowerCase().trim();
        const matchingCategory = sizeChartData.find(cat => 
          cat.shoes_category?.toLowerCase().trim() === shoeTypeLower
        );

        if (!matchingCategory || !matchingCategory.sizes) {
          delete drawer.dataset.rendering;
          return;
        }
        // Render the table
        const content = drawer.querySelector('.fit-finder-size-chart-drawer__content');
        if (!content) {
          delete drawer.dataset.rendering;
          return;
        }

        // Remove existing table wrappers
        content.querySelectorAll('.fit-finder-size-chart-drawer__table-wrapper').forEach(wrapper => wrapper.remove());

        // Find insertion point
        const detail2 = content.querySelector('.fit-finder-size-chart-drawer__detail:last-of-type');
        const insertBefore = detail2 || null;

        // Create table wrapper
        const tableWrapper = document.createElement('div');
        tableWrapper.className = 'fit-finder-size-chart-drawer__table-wrapper';

        // Build table HTML
        const titleText = sizeChartTitle2 || '';
        const tableHTML = `
          <div class="fit-finder-size-chart-drawer__table-header">
            ${titleText ? `<h3 class="fit-finder-size-chart-drawer__section-title">${titleText}</h3>` : ''}
            <div class="fit-finder-size-chart-drawer__unit-toggle">
              <button type="button" class="fit-finder-size-chart-drawer__unit-button fit-finder-size-chart-drawer__unit-button--active" data-unit="cm">cm</button>
              <button type="button" class="fit-finder-size-chart-drawer__unit-button" data-unit="in">in</button>
            </div>
          </div>
          <div class="fit-finder-size-chart-drawer__table-container" data-unit="cm">
            <table class="fit-finder-size-chart-drawer__table" data-category="${matchingCategory.shoes_category}">
              <thead>
                <tr>
                  <th>UK</th>
                  <th class="fit-finder-size-chart_white-bg">US</th>
                  <th>EU</th>
                  <th class="fit-finder-size-chart-drawer__unit-column fit-finder-size-chart_white-bg" data-unit="cm">
                    <span class="fit-finder-size-chart-drawer__unit-text" data-unit="cm">CM</span>
                    <span class="fit-finder-size-chart-drawer__unit-text" data-unit="in" style="display: none;">Inches</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                ${matchingCategory.sizes.map(size => `
                  <tr>
                    <td>${size.UK || ''}</td>
                    <td class="fit-finder-size-chart_white-bg">${size.US || ''}</td>
                    <td>${size.EU || ''}</td>
                    <td class="fit-finder-size-chart-drawer__unit-cell fit-finder-size-chart_white-bg" data-unit="cm">
                      <span class="fit-finder-size-chart-drawer__unit-value" data-unit="cm">${size.CM || ''}</span>
                      <span class="fit-finder-size-chart-drawer__unit-value" data-unit="in" style="display: none;">${size.Inches || ''}</span>
                    </td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;

        // Insert into DOM
        if (insertBefore) {
          content.insertBefore(tableWrapper, insertBefore);
        } else {
          content.appendChild(tableWrapper);
        }

        tableWrapper.innerHTML = tableHTML;

        // Clear rendering flag
        delete drawer.dataset.rendering;
      }
      /**
       * Opens the size chart drawer
       * Called from: theme.liquid when user clicks "Size Chart" button
       * 
       * @param {string} shoeType - Optional shoe type (Cricket/Walking/Lifestyle)
       */
      function openSizeChartDrawer(shoeType) {
        // Prevent double-opening
        if (window._sizeChartOpening) return;
        window._sizeChartOpening = true;

        // Get drawer
        const drawer = document.getElementById('fit-finder-size-chart-drawer');
        if (!drawer) {
          window._sizeChartOpening = false;
          return;
        }

        // Store shoe type
        if (shoeType) {
          drawer.dataset.shoeType = shoeType;
        }

        // Move to body if needed
        const quickAddModal = drawer.closest('.quick-add-modal, #quick-add-dialog');
        if (quickAddModal) {
          document.body.appendChild(drawer);
        }

        // Get dialog
        const dialog = drawer.querySelector('dialog');
        if (!dialog) {
          window._sizeChartOpening = false;
          return;
        }

        // If already open, just update chart
        if (dialog.hasAttribute('open')) {
          if (drawer.dataset.rendering !== 'true') {
            loadAndRenderSizeChart(shoeType);
          }
          window._sizeChartOpening = false;
          return;
        }

        // Open dialog
        if (customElements.get('dialog-component')) {
          if (typeof drawer.showDialog === 'function') {
            drawer.showDialog();
          } else if (drawer.refs?.dialog) {
            drawer.refs.dialog.showModal();
          } else {
            dialog.showModal();
          }
        } else {
          customElements.whenDefined('dialog-component').then(() => {
            if (typeof drawer.showDialog === 'function') {
              drawer.showDialog();
            } else if (drawer.refs?.dialog) {
              drawer.refs.dialog.showModal();
            } else {
              dialog.showModal();
            }
          }).catch(() => {
            dialog.showModal();
          });
        }

        // Render chart after dialog opens
        requestAnimationFrame(() => {
          loadAndRenderSizeChart(shoeType);
          window._sizeChartOpening = false;
        });
      }

      // Expose functions globally
      window.openSizeChartDrawer = openSizeChartDrawer;
      window.loadAndRenderSizeChart = loadAndRenderSizeChart;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
